export class FileHandler {
  static getFileSize(file: File) {
    return file ? FileHandler.convertOctetToMo(file.size) : 0;
  }
  static convertOctetToMo(size: any) {
    return size ? Number((size / 1048576).toFixed(2)) : 0; // convertir Octets en Megaoctets
  }
}
